const colors = {
  primaryBlue: '#41AADA',
  frostBlue: '#EBEFF5',
  black: '#152735',
  softGrey: '#F7F9FC',
  mediumGrey: '#585D64',
  gradientBlue: 'linear-gradient(177.61deg, #3db8f1 0%,#7db9e8 100%)'
}

export interface StyleClosetTheme {
  colors: { [key in keyof typeof colors]: string }
}

const theme: StyleClosetTheme = {
  colors
}

export { theme }
